import axios from './http'
import de from "element-ui/src/locale/lang/de";

/**
 * 跟投稿相关,管理员也用到
 * @type {{getAllList(): Promise<AxiosResponse<any>>, saveData(*=): Promise<AxiosResponse<*>>, getAllNotFinaledList(): Promise<AxiosResponse<any>>, getByUserId(): Promise<AxiosResponse<any>>, getEnterForStatus(*=): Promise<AxiosResponse<*>>, updateRound(*=): Promise<AxiosResponse<*>>}}
 */
const contribute = {

  /**
   *保存第一部分的投稿
   * @param thesis
   * @returns {Promise<AxiosResponse<any>>}
   */
  saveOneData(file, chName, enName, chKeyWords, enKeyWords) {
    let param = new FormData()//通过form数据格式来传
    param.append("route", file); //传文件
    param.append('chName', chName)
    param.append('enName', enName)
    param.append('chKeyWords', chKeyWords)
    param.append('enKeyWords', enKeyWords)
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    }
    return axios.post('/thesis/work', param)
  },

  /**
   * 用户查询自己作品+轮数+各轮终审意见/状态
   */
  getAllRoundThesisResult() {
    return axios.get('/thesis/work/getAllRoundThesisResult')
  },

  /**
   * 得到投稿
   */
  getByUserId() {
    return axios.get('/thesis/work')
  },

  /**
   * 得到报名状态
   * @param userName
   * @returns {Promise<AxiosResponse<any>>}
   */
  getEnterForStatus(userName) {
    let param = new URLSearchParams()
    param.append('verificationCode', '1')
    param.append('userName', userName)
    param.append('password', password)
    return axios.post('/thesis/auth/login', param)
  },

  /**
   * 上传文件
   * @param file
   * @param file1
   * @returns {Promise<AxiosResponse<any>>}
   */
  updateRound(thesisFile) {
    let param = new FormData()//通过form数据格式来传
    param.append("route", thesisFile); //传文件
    /*  let config = {
        headers: {
          //'Content-Type': 'multipart/form-data'
          cache: false,
          processData: false, // 不处理发送的数据，因为data值是Formdata对象，不需要对数据做处理
          contentType: false, // 不设置Content-type请求头
        }
      }*/


    return axios.post('/thesis/work/updateRound', param)
  },

  /**
   * 管理员指定审阅人
   * @param thesisIds 论文id集合,英文逗号分隔
   * @param refereeIds 审阅人id集合，英文逗号分隔
   */
  specifyReferee(thesisIds, refereeIds) {
    let param = new URLSearchParams()
    param.append('thesisIds', thesisIds)
    param.append('refereeIds', refereeIds)
    return axios.post('/thesis/work/specifyReferee', param)
  },

  /**
   * 审稿人查询自己当前轮数的所有审核作品
   */
  getAllByRefereeIdAndRoundNo(teamGrade){
    return axios.get(`/thesis/work/getAllByRefereeIdAndRoundNo?teamGrade=${teamGrade}`)
  },

  /**
   * 审稿人查询分配给自己的当前轮数的没有作出批复的作品
   * @return List<Thesis>
   */
  getNotRefereedByRefereeIdAndRoundNo(teamGrade){
    return axios.get(`/thesis/work/getNotRefereedByRefereeIdAndRoundNo?teamGrade=${teamGrade}`)
  },

  /**
   * 审稿人查询分配给自己的当前轮数的已经作出批复的作品
   */
  getRefereedByRefereeIdAndRoundNo(teamGrade,approvalGradeEnum){
    // let param = new URLSearchParams()
    // param.append('teamGrade', teamGrade)
    // param.append('approvalGradeEnum', approvalGradeEnum)
    let approvalGrade = approvalGradeEnum ? `&approvalGradeEnum=${approvalGradeEnum}` : ''
    return axios.get(`/thesis/work/getRefereedByRefereeIdAndRoundNo?teamGrade=${teamGrade}` + approvalGrade)
  },

  /**
   * 管理员-尝试读取doc为pdf，并展示
   * @param id abstractFileName，带用户id的那个路径
   * @param request
   * @param response
   */
  displayPDFOfManager(id){
    //id = encodeURIComponent(id)
    let config={
      //responseType: "arraybuffer",
      /*responseType:'blob',
      headers: {'Content-Type': 'application/x-www-form-urlencoded'}*/
    }
    return axios.get('/thesis/work/displayPDFOfManager?id='+id,config)
  },

  /**
   * 获取上传作品文件-给审稿人或管理员使用
   * @param request
   * @param response
   * @param path abstractFileName，带用户id的那个路径
   */
  getWorksOfManager(path){
    path = encodeURIComponent(path)
    let config={
      responseType:'blob',
    }
    return axios.get('/thesis/work/getWorksOfManager?path='+path,config)
  },

  /**
   * 管理员给定终审意见
   * @param thesisId
   * @param refereeOpinionInfo
   * @param refereeStatusEnum 意见为：APPROVED或者REFUSED
   * @return
   */
  giveFinalRefereeOpinion(thesisId,refereeOpinionInfo,refereeStatusEnum,approvalGradeEnum){
    let param = new URLSearchParams()
    param.append('thesisId', thesisId)
    param.append('refereeOpinionInfo', refereeOpinionInfo)
    param.append('refereeStatusEnum', refereeStatusEnum)
    param.append('approvalGradeEnum', approvalGradeEnum)
    return axios.post('/thesis/work/giveFinalRefereeOpinion', param)
  },

  /**
   * 管理员查询当前轮数未终审的论文
   */
  getAllNotFinaledList(teamGrade) {
    return axios.get(`/thesis/work/getAllNotFinaledList?teamGrade=${teamGrade}`)
  },

  /**
   * 得到所有的投稿
   */
  getAllList(roundNo,teamGrade) {
    return axios.get('/thesis/work/getAllList?roundNo='+roundNo+`&teamGrade=${teamGrade}`)
  },

  /**
   * 管理员查询某轮所有已经终审结束的论文
   *  roundNo 轮数小于等于0时，表示查询当前轮数的结果；1/2/3则查询指定轮数结果
   * @return List<Thesis>
   */
  getAllFinaledListByRoundNo(roundNo,teamGrade){
    return axios.get('/thesis/work/getAllFinaledListByRoundNo?roundNo='+roundNo+`&teamGrade=${teamGrade}`)
  },

  /**
   * 管理员获取某轮终审结束且通过的论文
   *  roundNo 轮数小于等于0时，表示查询当前轮数的结果；1/2/3则查询指定轮数结果
   * @return List<Thesis>
   */
  getAllFinaledApprovedListByRoundNo(roundNo,teamGrade,approvalGradeEnum){
    return axios.get('/thesis/work/getAllFinaledApprovedListByRoundNo?roundNo='+roundNo+`&teamGrade=${teamGrade}&approvalGradeEnum=${approvalGradeEnum}`)
  },

  /**
   * 管理员获取某轮终审结束且拒绝的论文
   *  roundNo 轮数小于等于0时，表示查询当前轮数的结果；1/2/3则查询指定轮数结果
   * @return List<Thesis>
   */
  getAllFinaledRefusedListByRoundNo(roundNo,teamGrade){
    return axios.get('/thesis/work/getAllFinaledRefusedListByRoundNo?roundNo='+roundNo+`&teamGrade=${teamGrade}`)
  },

  /**
   * 管理员查询当前轮数未终审且未分配过审核人的论文
   * @return List<ThesisVo>
   */
  getAllNotFinaledAndNotSpecifyedList(teamGrade){
    return axios.get(`/thesis/work/getAllNotFinaledAndNotSpecifyedList?teamGrade=${teamGrade}`)
  },

  /**
   * 管理员查询当前轮数未终审且已分配过审核人的论文
   * @return List<ThesisVo>
   */
  getAllNotFinaledAndSpecifyedList(teamGrade){
    return axios.get(`/thesis/work/getAllNotFinaledAndSpecifyedList?teamGrade=${teamGrade}`)
  },

  /**
   * 审稿人给定初审意见
   * @param thesisId
   * @param refereeOpinionInfo
   * @param refereeStatusEnum 意见为：APPROVED或者REFUSED
   * @return
   */
  giveRefereeOpinion(thesisId,refereeOpinionInfo,refereeStatusEnum,approvalGradeEnum){
    let param = new URLSearchParams()
    param.append('thesisId', thesisId)
    param.append('refereeOpinionInfo', refereeOpinionInfo)
    param.append('refereeStatusEnum', refereeStatusEnum)
    param.append('approvalGradeEnum', approvalGradeEnum)
    return axios.post('/thesis/work/giveRefereeOpinion', param)

  }
}

export default contribute



// WEBPACK FOOTER //
// ./src/api/contribute.js